module.exports = " <div class=newsview> <div class=view-content> {{content}} <p>点击次数为：{{count}}</p> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.5.4@vue-loader/lib/selector.js?type=template&index=0!./src/modules/newsView.vue
// module id = 28
// module chunks = 2